import { CurrencyPipe } from '@angular/common';
import {
  AfterContentInit,
  AfterViewInit,
  Component,
  forwardRef,
  Host,
  HostListener,
  Input,
  OnInit,
  Optional,
  SkipSelf
} from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { constants } from 'src/app/config/constants';
import { inputMgsErrs } from 'src/app/validators/message-validation';
import { FormComponentControl } from '../form-component-control';

@Component({
  selector: 'app-input-text',
  templateUrl: './input-text.component.html',
  styleUrls: ['./input-text.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputTextComponent),
      multi: true
    }
  ]
})
export class InputTextComponent extends FormComponentControl implements OnInit, AfterContentInit, AfterViewInit {

  @Input() groupClass = 'mb-3';
  @Input() labelClass = 'mb-1';
  @Input() inputClass = '';
  @Input() inputStyleClass = '';
  @Input() labelCurrencyStyle = '';
  @Input() isCurrency: boolean;
  @Input() isDisabled: boolean;
  @Input() numberOnly: boolean;
  @Input() maxlength: string;
  @Input() type: 'text' | 'date' | 'password' = 'text';
  @Input() keyMessageErrors: 'firstName' | 'lastName' | 'userAge' | 'dateText' | 'agentCode' | 'password' | 'confirmPassword';
  maxCurrency = constants.maxCurrency;

  constructor(
    @Optional() @Host() @SkipSelf()
    private cc: ControlContainer,
    private translate: TranslateService,
    private currencyPipe: CurrencyPipe
  ) {
    super(cc);
  }

  get isDateType(): boolean {
    return this.type === 'date';
  }

  get isMaxLengthForDate(): boolean {
    return this.value ? this.value.length >= 8 : false;
  }

  ngOnInit() {
    if (navigator.appVersion.toString().indexOf('.NET') > 0) {
      this.browserIE = true;
    }
    this.checkInitialControl();
  }

  ngAfterContentInit(): void {
    if (this.control) {
      this.control.valueChanges.subscribe(val => {
        if (this._isBlur) {
          setTimeout(() => {
            this.innerValueFormat();
          });
        }
      });
    }
    this.initialValueErrors();
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.value) {
        this.onBlur();
      }
    });
  }

  onBlur() {
    super.onBlur();
    this.innerValueFormat();
  }

  onFocus() {
    super.onFocus();
    if (this.isCurrency && this.value) {
      this.value = this.value.replace(/,/g, '');
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: any) {
    // ClipboardEvent
    if (this.isCurrency) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  @HostListener('drop', ['$event'])
  onDrop(event: any) {
    // DragEvent
    if (this.isCurrency) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  protected setValue(val: any) {
    super.setValue(val);
    if (this._isBlur) {
      this.innerValueFormat();
    }
  }

  private innerValueFormat() {
    if (this.isCurrency) {
      try {
        const pattern = new RegExp(/,/g);
        let val = this.value;
        val = pattern.test(val) ? (val as string).replace(pattern, '') : val;
        this.innerValue = this.currencyPipe.transform(val, '', '', '1.2-2');
        // this.innerValue = this.currencyPipe.transform(Math.round(val), '', '', '1.0-2');
      } catch (e) {
        this.innerValue = '0';
        this.value = 0;
      }
    }
  }

  private initialValueErrors() {
    if (this.isCurrency) {
      this.errors = inputMgsErrs.currency;
    } else {
      this.errors = inputMgsErrs[this.keyMessageErrors];
      if (!this.errors) {
        this.errors = inputMgsErrs.default;
      }
    }
  }
}
